import Elemento from "./Elemento.js";

export default class Aplicacion extends Elemento {
  constructor() {
    super();
    this.ficha = null; // configurable o standard
    this.manual = null;
    this.video = null;
    this.tipo = "configurable"; // configurable o standard
    this.view = {
      Live: "2d",
      Delay: "2d",
    };
    this.datosEstandar;
    this.datosConfigurable;
    this.datos3Drender;
    this.colecciones = new Array();
    this.languageSel;
    this.coleccionSel = {};
    this.grupoSel = {
      Live: {},
      Delay: {},
    };
    this.priceObj = {};

    this.montajeExists = function () {
      var grupos = this.coleccionSel.sideSel.Live.grupos;

      var bool = grupos.find((grupo) => grupo.cod === "MONTAJE") !== undefined;

      return bool;
    };

    this.GetCodigoEstandar = function () {
      var codigo;
      var campo;
      var caracteristicas;
      
      // Se hace una copia
      caracteristicas = JSON.stringify(this.datosEstandar.caracteristicas);
      caracteristicas = JSON.parse(caracteristicas);
      // Se obtiene el campo posicionFijo
      campo = this.coleccionSel.sideSel.Live.GetCampo("posicionFijo");
      campo.visible = true;
      if (campo.acabados.length <= 1) {
        // Se oculta el campo posicionFijo
        campo.visible = false;
        // Se busca incluyendo posicionFijo
        //console.log(1, "Buscando con posicionFijo");
        codigo = this.GetCodigoEstandar2(caracteristicas);
        // Si no lo encuentra se busca sin posicionFijo
        if (codigo == "ERROR") {
          //console.log(2, "Buscando sin posicionFijo");
          delete caracteristicas.posicionFijo;
          codigo = this.GetCodigoEstandar2(caracteristicas);
        }
      } else {
        //console.log(1, "Buscando con posicionFijo");
        // Se busca incluyendo posicionFijo
        codigo = this.GetCodigoEstandar2(caracteristicas);
        // Si no lo encuentra significa que en la combinación no se incluye posicionFijo,
        // se oculta el campo y se busca sin posicionFijo,
        if (codigo == "ERROR") {
          campo.visible = false;
          //console.log(2, "Buscando sin posicionFijo");
          delete caracteristicas.posicionFijo;
          codigo = this.GetCodigoEstandar2(caracteristicas);
        } else {
          campo.visible = true;
        }
      }
      
      return codigo;
    };
    this.GetCodigoEstandar2 = function (caracteristicas) {
      var codigos = this.datosEstandar.codigos;
      var campo;
      var acabado;
      var error = false;
      var sentencia = "";
      var retorno;
      var filtro;

      if (this.tipo != "estandar") {
      
        return "ERROR";
      }

      for (const clave in caracteristicas) {
        if (caracteristicas.hasOwnProperty(clave) && clave != 'montaje') {
          campo = this.coleccionSel.sideSel.Live.GetCampo(clave);
          //console.log(caracteristicas[clave]);
          acabado = campo.acabadoSel;

          sentencia +=
            "linea." +
            campo.cod +
            " == " +
            "'" +
            campo.acabadoSel.cod +
            "'" +
            " && ";
        }
      }

      if (error) {
        //console.log("Error al obtener el código");
        retorno = "ERROR";
      } else {
        sentencia = sentencia.slice(0, -4);
        filtro = codigos.filter((linea) => {
          return eval(sentencia);
        });

        if (filtro.length == 1) {
          retorno = filtro[0].codigo;
          // Actualiza el objeto del precio de la aplicacion
          this.priceObj.codigo = filtro[0].codigo;
          this.priceObj.configurable = false;
          this.priceObj.id = -1;
          this.priceObj.moneda = "EUR";
          //console.log(retorno, sentencia);
        } else if (filtro.length == 0) {
          retorno = "ERROR";
          //console.log("Error: no encuentra el código que cumpla:", sentencia);
        } else {
          retorno = "ERROR";
          //console.log("Error: más de un código", sentencia);
        }
      }

      return retorno;
    };
  }
}
